import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import styleA from './style'
import styleB from '../../style'

import Container from '../../partials/Container'
import UserTable from '../../partials/UserTable'

import Selector from './partials/Selector'

import user from '../../../../utils/user'
import access from '../../../../utils/access'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Community', 'Auth', 'User', 'Config')
@observer
export class CommunityUser extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      active: {},
      editor: {
        search: {
          active: false,
          value: ''
        },
        group: -1
      }
    }
  }

  onSearchInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        search: {
          ...this.state.editor.search,
          value: e.target.value
        }
      }
    })
  }

  onEditClick () {
    if (this.state.active.id) {
      return this.props.history.push(
        `${this.props.location.pathname}/${this.state.active.id}`
      )
    }

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        enabled: !this.state.editor.enabled
      }
    })
  }

  onUserClick (e) {
    const userId = e.currentTarget.dataset.userid

    if (this.state.editor.enabled || this.state.editor.search.active) {
      return this.props.history.push(
        `${this.props.location.pathname}/${userId}`
      )
    }

    this.setState({
      ...this.state,
      active: {
        ...this.state.active,
        id: userId
      }
    })
  }

  onAddClick (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        search: {
          ...this.state.editor.search,
          active: true
        }
      }
    })
  }

  onSearchSubmit (e) {
    e.preventDefault()

    this.props.User.searchUsers(this.state.editor.search.value)
    console.log('search!!!!!!')
  }

  onGroupChange (e) {
    e.preventDefault()
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        group: e.target.value
      }
    })
  }

  render () {
    const comId = this.props.match.params.comId
    const userGroups = (this.props.Community.groups[comId] || [])
      .slice()
      .reduce(
        (arr, g) => [
          ...arr,
          ...(g.users.includes(this.props.Auth.token.userId) ? [g] : [])
        ],
        []
      )
    const userPerms = user.parsePermList({ groups: userGroups })

    return (
      <Container {...this.props}>
        <Row>
          <Col xs='12' lg={this.state.editor.search.active ? `6` : `4`}>
            <h2 className={css(styleB.headers.h2)}>
              {this.state.editor.search.active ? `Add Member` : `Members`}
            </h2>
          </Col>
          <Col
            style={{
              overflow: `hidden`,
              position: `relative`,
              transition: `0.2s`
            }}
          >
            {!access.comGroup(userPerms) &&
            !access.adminCom(this.props.User.me.permissions || {})
              ? null
              : [
                <SearchArea
                  key={0}
                  theme={THEME_LIST[this.props.Config.theme]}
                  style={{
                    transition: `0.2s`,
                    width: `100%`,
                    position: `absolute`,
                    ...(this.state.editor.search.active
                        ? {
                          top: 0,
                          left: `15px`
                        }
                        : {
                          top: `-100px`,
                          left: `15px`
                        })
                  }}
                  onInputChange={this.onSearchInputChange.bind(this)}
                  onSubmit={this.onSearchSubmit.bind(this)}
                  editor={this.state.editor}
                  />,
                <NavigationArea
                  key={1}
                  style={{
                    transition: `0.2s`,
                    width: `100%`,
                    position: `absolute`,

                    ...(!this.state.editor.search.active
                        ? {
                          top: 0,
                          left: `15px`
                        }
                        : {
                          top: `100px`,
                          left: `15px`
                        })
                  }}
                  editor={this.state.editor}
                  onGroupChange={this.onGroupChange.bind(this)}
                  onEditClick={this.onEditClick.bind(this)}
                  onAddClick={this.onAddClick.bind(this)}
                  groups={(this.props.Community.groups[comId] || []).slice()}
                  />
              ]}
          </Col>
        </Row>
        <Row>
          <UserTable
            theme={THEME_LIST[this.props.Config.theme]}
            users={
              this.state.editor.search.active
                ? this.props.User.search.slice().reduce(
                    (arr, u) => [
                      ...arr,
                      {
                        ...u,
                        groups: (
                          this.props.Community.groups[comId] || []
                        ).reduce(
                          (_arr, g) => [
                            ..._arr,
                            ...(g.users.indexOf(u.id) > -1 ? [g] : [])
                          ],
                          []
                        )
                      }
                    ],
                    []
                  )
                : (this.props.Community.users[comId] || []).reduce(
                    (arr, u) => [
                      ...arr,
                      ...(![-1, '-1'].includes(this.state.editor.group)
                        ? (
                            this.props.Community.groups[comId].find(
                              g => g.id === this.state.editor.group
                            ) || {}
                          ).users.includes(u.id)
                          ? [
                            {
                              ...u,
                              groups: (
                                  this.props.Community.groups[comId] || []
                                ).reduce(
                                  (_arr, g) => [
                                    ..._arr,
                                    ...(g.users.indexOf(u.id) > -1 ? [g] : [])
                                  ],
                                  []
                                )
                            }
                          ]
                          : []
                        : [
                          {
                            ...u,
                            groups: (
                                this.props.Community.groups[comId] || []
                              ).reduce(
                                (_arr, g) => [
                                  ..._arr,
                                  ...(g.users.indexOf(u.id) > -1 ? [g] : [])
                                ],
                                []
                              )
                          }
                        ])
                    ],
                    []
                  )
            }
            activeId={this.state.active.id}
            onUserClick={this.onUserClick.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

const SearchArea = props => {
  return (
    <form
      onSubmit={props.onSubmit}
      style={props.style || {}}
      className={`row ${css(
        styleA.search.container,
        styleA[props.theme.name]
          ? styleA[props.theme.name].search.container
          : null
      )}`}
    >
      <Col
        className={css(
          styleA.search.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].search.inputWrapper
            : null
        )}
      >
        <input
          type={`text`}
          placeholder={`search...`}
          value={props.editor.search.value}
          onChange={props.onInputChange}
          className={css(styleA.search.input)}
        />
      </Col>
      <Col xs='4' className={css(styleA.search.inputWrapper)}>
        <button
          className={css(
            styleB.buttons.button,
            styleB.buttons.red,
            styleA.search.button
          )}
        >
          Search
        </button>
      </Col>
    </form>
  )
}

const NavigationArea = props => {
  return (
    <Row style={props.style || {}}>
      <Col lg='3'>
        <Selector
          value={props.editor.group}
          onChange={props.onGroupChange}
          options={props.groups.map(g => ({ value: g.id, label: g.name }))}
        />
      </Col>
      <Col>
        <span
          className={css(
            styleB.buttons.button,
            styleB.buttons.red,
            props.editor.enabled ? styleB.buttons.redActive : null
          )}
          onClick={props.onEditClick}
        >
          Edit
        </span>
      </Col>
      <Col>
        <span
          className={css(styleB.buttons.button, styleB.buttons.red)}
          onClick={props.onAddClick}
        >
          Add new
        </span>
      </Col>
    </Row>
  )
}

export default CommunityUser



// WEBPACK FOOTER //
// ./src/components/Community/User/Main/index.js